import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppLocale } from '../../../i18n/localeUtils'
import { Button, Divider, Grid, Paper, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'
import { FormProvider, useForm } from 'react-hook-form'

import useAuth from '../../../hooks/useAuth'

import TestDateApi from '../../../api/TestDateApi'
import { formatDateYYYYMMDD, formatDateYYYYMMDDhhmm } from '../../../packages/utils/numberFormatters'
import { RegisteredDatePicker } from '../../../components/fields/DatePicker'
import { RegisteredTextField } from '../../../components/fields/TextField'
import { Stack } from '@mui/material'

function RenderDate({ date, label }) {
        const { language } = useAppLocale()

    if (!date) return null
    try {
        return (
            <Typography>
                {label}: <br />
                Rå date: {date} <br />
                formatDateYYYYMMDD: {formatDateYYYYMMDD(date, { locale: language })} <br />
                formatDateYYYYMMDDhhmm: {formatDateYYYYMMDDhhmm(date, { locale: language })} <br />
            </Typography>
        )
    } catch (error) {
        return (
            <Typography>
                {label}: date: {date}, {error.message}
            </Typography>
        )
    }
}

function TestDatesView({ dates }) {
    if (!dates) return null
    return (
        <Stack spacing={2}>
            <Typography variant='h4'>{dates.description}</Typography>
            <RenderDate date={dates.dateAsDate} label='dateAsDate' />
            <RenderDate date={dates.datetimeAsDatetime} label='datetimeAsDatetime' />
            <RenderDate date={dates.timestampAsTimestamp} label='timestampAsTimestamp' />
            <RenderDate date={dates.timeAsTime} label='timeAsTime' />
        </Stack>
    )
}

function TestDatesForm({ dates, onSubmit }) {
    const formMethods = useForm({ defaultValues: { ...dates } })

    if (!dates) {
        return null
    }

    console.log('dates', dates)
    console.log('formMethods dates', formMethods.getValues())

    return (
        <FormProvider {...formMethods}>
            <form onSubmit={formMethods.handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <RegisteredDatePicker name='dateAsDate' label='dateAsDate' />
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <RegisteredDatePicker name='datetimeAsDatetime' label='datetimeAsDatetime' />
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <RegisteredDatePicker name='timestampAsTimestamp' label='timestampAsTimestamp' />
                    </Grid>
                    {/* <RegisteredDatePicker name='timeAsTime' label='timeAsTime' /> */}
                    <Grid size={12}>
                        <RegisteredTextField name='description' label='description' />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Button variant='contained' type='submit'>
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </FormProvider>
    )
}

function TestDates() {
    const [dates, setDates] = useState(null)
    const { isAuthenticated } = useAuth()
    useEffect(() => {
        const fetchData = async () => {
            if (!isAuthenticated) return
            const api = new TestDateApi()
            let result = await api.adminGetAllTestDates()
            console.log('result', result)
            if (result?.length > 0) {
                result = result[0] // we only have (pr at least only use) one record
            }
            setDates(result)
        }
        fetchData()
    }, [isAuthenticated])

    const onSubmit = async (data) => {
        const api = new TestDateApi()
        console.log('onSubmit data', data)
        const result = await api.adminUpdateTestDate(data)
        if (result) {
            setDates(result)
        }
    }

    return (
        <>
            <Helmet title='Datumtest' />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'inline',
                }}
            >
                Datumtest
            </Typography>
            <Divider sx={{ my: 6 }} />
            <TestDatesView dates={dates} />
            <Divider sx={{ my: 6 }} />
            <Paper elevation={6} sx={{ p: 6 }}>
                {dates && <TestDatesForm dates={dates} onSubmit={onSubmit} />}
            </Paper>
        </>
    )
}

export default TestDates
